import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import ReleaseNoteItems, { ReleaseNoteItemVM } from '../dashboard/ReleaseNoteItems';
import { SHARED_RELEASE_NOTE_QUERY } from '../../graphql/queries';
import BrandMark from '../../components/common/BrandMark';
import styles from './PublicReleaseNote.module.css';

const formatDate = (iso: string): string =>
  new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' });

// Public share page — reachable without an account (the unguessable token IS
// the authorization, same model as project share links).
const PublicReleaseNote = () => {
  const { token } = useParams<{ token: string }>();
  const { data, loading } = useQuery(SHARED_RELEASE_NOTE_QUERY, {
    variables: { token },
    skip: !token,
    fetchPolicy: 'cache-and-network',
  });
  const note = data?.sharedReleaseNote as { version: string; releaseDate: string; items: ReleaseNoteItemVM[] } | null | undefined;

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <BrandMark size={28} decorative />
        <span className={styles.brand}>Infrio</span>
        <span className={styles.headerLabel}>Release notes</span>
      </header>

      <main className={styles.body}>
        {loading && !note ? (
          <div className={styles.centerState}>
            <span className="material-symbols-outlined animate-spin mr-2">refresh</span>
            Loading...
          </div>
        ) : !note ? (
          <div className={styles.centerState}>
            <span className="material-symbols-outlined" style={{ fontSize: 40 }}>link_off</span>
            <p>This share link is invalid or has been revoked.</p>
          </div>
        ) : (
          <>
            <div className={styles.head}>
              <h1 className={styles.title}>Version {note.version}</h1>
              <p className={styles.date}>{formatDate(note.releaseDate)}</p>
            </div>
            <ReleaseNoteItems items={note.items} />
          </>
        )}
      </main>
    </div>
  );
};

export default PublicReleaseNote;
